import { icon } from 'leaflet';
import { FormattedMessage } from 'react-intl';

export const MENU_SIDEBAR = [{
  title: 'Dashboard',
  icon: 'element-11',
  children: [{
    title: 'Home',
    path: '/'
  }, {
    title: 'Dark Sidebar',
    path: '/dark-sidebar'
  }]
}, {
  title: 'Secure File Sharing',
  icon: 'element-11',
  children: [{
    title: 'Secure File Sharing',
    path: '/shared-storage'
  }]
}, {
  title: 'Contacts',
  icon: 'element-11',
  children: [{
    title: 'Contacts List',
    path: '/contacts'
  }]
}, {
  title: 'Contacts',
  icon: 'element-11',
  children: [{
    title: 'Create Contact',
    path: '/contacts/create'
  }]
}, {
  title: 'Matters',
  icon: 'element-11',
  children: [{
    title: 'Matters List',
    path: '/matters'
  }]
}, {
  title: 'Dashboard',
  icon: 'element-11',
  children: [{
    title: 'Archive Matters',
    path: '/matters/archive-matters'
  }]
}, {
  title: 'Matters',
  icon: 'element-11',
  children: [{
    title: 'Create Matter',
    path: '/matters/create'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Flat Fees',
    path: '/billing/flat-fees'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Create Flat Fees',
    path: '/billing/flat-fees/create'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Edit Flat Fees',
    path: '/billing/flat-fees/edit'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Expenses',
    path: '/billing/expense'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Create Expense',
    path: '/billing/expense/create'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Edit Expense',
    path: '/billing/expense/edit'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Items',
    path: '/billing/items'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Invoice',
    path: '/billing/invoices/invoice'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Invoice',
    path: '/billing/invoices/invoice-template'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Pricing',
    path: '/company-billing/license'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Invoice Preview',
    path: '/billing/invoices/invoice-view'
  }]
}, {
  title: 'Billing',
  icon: 'element-11',
  children: [{
    title: 'Plan Usage',
    path: '/billing/summary'
  }]
}, {
  title: 'Reports',
  icon: 'element-11',
  children: [{
    title: 'AR Report – Due Invoices',
    path: '/reports/ar-report',
  }, {
    title: 'Raw Data Report',
    path: '/reports/raw-data-report',
  }, {
    title: 'ADHOC Report',
    path: '/reports/adhoc-report',
  }]
}, {
  title: 'Documents',
  icon: 'element-11',
  children: [{
    title: 'E-Signature Documents',
    path: '/documents/e-signature-documents',
  },
  {
    title: 'Document Templates',
    path: '/documents/document-templates',
  },
  {
    title: 'Letter Templates',
    path: '/documents/letter-templates',
  },
  {
    title: 'Demand Letters',
    path: '/documents/demand-letters',
  }]
}, {
  title: 'Data Import',
  icon: 'element-11',
  children: [{
    title: 'Import your data',
    path: '/data-import/import',
  }]
},
{
  title: 'Data Import Details',
  path: '/data-import/details',

},
// {
//   title: 'Data Import',
//   icon: 'element-11',
//   children: [{
//     title: 'Data Import Details',
//     path: '/data-import/details',
//   }]
// },
{
  title: 'Notifications',
  icon: 'element-11',
  permission: { action: 'access', subject: 'notification' },
  children: [{
    title: 'All Notification',
    path: '/notifications/all',
    permission: { action: 'access', subject: 'notification' },
  }]
},
{
  heading: 'User'
}, {
  title: <FormattedMessage id="HOME" />,
  icon: 'element-11',
  children: [{
    title: 'Attorney Registration Requests',
    path: '/account/home/referral-request'
  }, {
    title: <FormattedMessage id="REFERRAL.REFERRED_CONTACT" />,
    path: '/account/home/referral-attorney',
  }, {
    title: <FormattedMessage id="REFERRED.ADD_REFERRED_CONTACT" />,
    path: '/account/home/referred-contact-list',
  }, {
    title: <FormattedMessage id="REFERRED.REFERRED_CONTACT_LIST" />,
    path: '/account/home/attorney-referred-contact-list',
  }]
},
{
  title: 'Home',
  icon: 'element-11',
  children: [{
    title: 'Referral Attorney',
    path: '/account/home/referral-attorney'
  }]
}, {
  title: 'Basic Setup',
  children: [{
    title: 'Invoice Setup',
    children: [{
      title: 'Expense Categories',
      path: '/billing/expense/category'
    }, {
      title: 'Invoice Templates',
      path: '/billing/invoice/invoice-template',
    }, {
      title: 'Taxes',
      path: '/billing/taxes',
    }]
  }, {
    title: 'Email Setup',
    children: [{
      title: 'Email Signature',
      path: '/mass-mailing/signature',
      icon: 'message-edit'
    }]
  }, {
    title: 'Manage Users',
    children: [{
      title: 'Roles',
      path: '/account/members/roles'
    }, {
      title: 'Users',
      path: '/account/members/users'
    },]
  }, {
    title: 'Contact Type',
    path: '/contacts/contact-type'
  }, {
    title: 'Specialties',
    path: '/contacts/specialities'
  }, {
    title: 'Custom Fields',
    path: '/account/home/custom-fields',
  }, {
    title: 'Record Types',
    path: '/account/home/record-types',
  }, {
    title: 'Tags',
    path: '/account/home/tags',
  },
  // {
  //   title: 'Fields Mapping',
  //   path: '/account/home/map-fields',
  // },
  {
    title: 'Referral',
    path: '/account/home/referral',
  },
  ]
}, {
  title: <FormattedMessage id="user_profile.my_account" />,
  icon: 'setting-2',
  children: [{
    title: <FormattedMessage id="user_profile.account" />,
    children: [{
      title: 'Get Started',
      path: '/account/home/get-started'
    }, {
      title: 'Recycle Bin',
      path: '/recycle-bin',
    }, {
      // Export approval (OL-154). Anyone who can export may need to collect an
      // approved export here; admins review requests on the same page.
      title: 'Export Requests',
      path: '/account/export-requests',
      permission: { action: 'export', subject: 'data' },
    }, {
      // Firm-wide audit log (OL-156). No role grants "view audit-log"; only
      // administrators pass, through their manage-all ability.
      title: 'Audit Log',
      path: '/account/audit-log',
      permission: { action: 'view', subject: 'audit-log' },
    }, {
      title: <FormattedMessage id="user_profile.user_profile" />,
      path: '/account/home/user-profile'
    }, {
      title: 'Company Profile',
      path: '/account/home/company-profile'
    }, {
      title: 'Settings - With Sidebar',
      path: '/account/home/settings-sidebar'
    }, {
      title: 'Settings - Enterprise',
      path: '/account/home/settings-enterprise'
    }, {
      title: 'Settings - Plain',
      path: '/account/home/settings-plain'
    }, {
      title: 'Settings - Modal',
      path: '/account/home/settings-modal'
    }]
  }, {
    title: 'Billing',
    children: [{
      title: 'Billing - Basic',
      path: '/account/billing/basic'
    }, {
      title: 'Billing - Enterprise',
      path: '/account/billing/enterprise'
    }, {
      title: 'Plans',
      path: '/account/billing/plans'
    }, {
      title: 'Billing History',
      path: '/account/billing/history'
    }]
  }, {
    title: <FormattedMessage id="account_security.security" />,
    children: [{
      title: 'Get Started',
      path: '/account/security/get-started'
    }, {
      title: <FormattedMessage id="account_security.security_overview" />,
      path: '/account/security/overview'
    }, {
      title: 'Allowed IP Addresses',
      path: '/account/security/allowed-ip-addresses'
    }, {
      title: 'Privacy Settings',
      path: '/account/security/privacy-settings'
    }, {
      title: 'Device Management',
      path: '/account/security/device-management'
    }, {
      title: 'Backup & Recovery',
      path: '/account/security/backup-and-recovery'
    }, {
      title: 'Current Sessions',
      path: '/account/security/current-sessions'
    }, {
      title: 'Security Log',
      path: '/account/security/security-log'
    }]
  }, {
    title: 'Members & Roles',
    children: [{
      title: 'Teams Starter',
      path: '/account/members/team-starter'
    }, {
      title: 'Teams',
      path: '/account/members/teams'
    }, {
      title: 'Team Info',
      path: '/account/members/team-info'
    }, {
      title: 'Members Starter',
      path: '/account/members/members-starter'
    }, {
      title: 'Team Members',
      path: '/account/members/team-members'
    }, {
      title: 'Import Members',
      path: '/account/members/import-members'
    }, {
      title: 'Permissions - Toggler',
      path: '/account/members/permissions-toggle'
    }, {
      title: 'Permissions - Check',
      path: '/account/members/permissions-check'
    }]
  }, {
    title: 'Integrations',
    path: '/account/integrations'
  }, {
    title: 'Notifications',
    path: '/account/notifications'
  }, {
    title: 'API Keys',
    path: '/account/api-keys'
  }, {
    title: 'More',
    collapse: true,
    collapseTitle: 'Show less',
    expandTitle: 'Show 3 more',
    dropdownProps: {
      placement: 'right-start'
    },
    children: [{
      title: 'Appearance',
      path: '/account/appearance'
    }, {
      title: 'Invite a Friend',
      path: '/account/invite-a-friend'
    }, {
      title: 'Activity',
      path: '/account/activity'
    }]
  }]
}, {
  title: 'Network',
  icon: 'users',
  children: [{
    title: 'Get Started',
    path: '/network/get-started'
  }, {
    title: 'User Cards',
    children: [{
      title: 'Mini Cards',
      path: '/network/user-cards/mini-cards'
    }, {
      title: 'Team Crew',
      path: '/network/user-cards/team-crew'
    }, {
      title: 'Author',
      path: '/network/user-cards/author'
    }, {
      title: 'NFT',
      path: '/network/user-cards/nft'
    }, {
      title: 'Social',
      path: '/network/user-cards/social'
    }]
  }, {
    title: 'User Table',
    children: [{
      title: 'Team Crew',
      path: '/network/user-table/team-crew'
    }, {
      title: 'App Roster',
      path: '/network/user-table/app-roster'
    }, {
      title: 'Market Authors',
      path: '/network/user-table/market-authors'
    }, {
      title: 'SaaS Users',
      path: '/network/user-table/saas-users'
    }, {
      title: 'Store Clients',
      path: '/network/user-table/store-clients'
    }, {
      title: 'Visitors',
      path: '/network/user-table/visitors'
    }]
  }, {
    title: 'Cooperations',
    path: '/network/cooperations',
    disabled: true
  }, {
    title: 'Leads',
    path: '/network/leads',
    disabled: true
  }, {
    title: 'Donators',
    path: '/network/donators',
    disabled: true
  }]
}, {
  title: 'Authentication',
  icon: 'security-user',
  children: [{
    title: 'Classic',
    children: [{
      title: 'Sign In',
      path: '/auth/classic/login'
    }, {
      title: 'Sign Up',
      path: '/auth/classic/signup'
    }, {
      title: '2FA',
      path: '/auth/classic/2fa'
    }, {
      title: 'Check Email',
      path: '/auth/classic/check-email'
    }, {
      title: 'Reset Password',
      children: [{
        title: 'Enter Email',
        path: '/auth/classic/reset-password/enter-email'
      }, {
        title: 'Check Email',
        path: '/auth/classic/reset-password/check-email'
      }, {
        title: 'Change Password',
        path: '/auth/classic/reset-password/change'
      }, {
        title: 'Password Changed',
        path: '/auth/classic/reset-password/changed'
      }]
    }]
  }, {
    title: 'Branded',
    children: [{
      title: 'Sign In',
      path: '/auth/login'
    }, {
      title: 'Sign Up',
      path: '/auth/signup'
    }, {
      title: '2FA',
      path: '/auth/2fa'
    }, {
      title: 'Check Email',
      path: '/auth/check-email'
    }, {
      title: 'Reset Password',
      children: [{
        title: 'Enter Email',
        path: '/auth/reset-password/enter-email'
      }, {
        title: 'Check Email',
        path: '/auth/reset-password/check-email'
      }, {
        title: 'Change Password',
        path: '/auth/reset-password/change'
      }, {
        title: 'Password Changed',
        path: '/auth/reset-password/changed'
      }]
    }]
  }, {
    title: 'Welcome Message',
    path: '/auth/welcome-message'
  }, {
    title: 'Account Deactivated',
    path: '/auth/account-deactivated'
  }, {
    title: 'Error 404',
    path: '/error/404'
  }, {
    title: 'Error 500',
    path: '/error/500'
  }]
}, {
  heading: 'Apps'
}, {
  title: 'User Management',
  icon: 'users',
  disabled: true
}, {
  title: 'Projects',
  icon: 'questionnaire-tablet',
  disabled: true
}, {
  title: 'eCommerce',
  icon: 'handcart',
  disabled: true
}, {
  heading: 'Miscellaneous'
}, {
  title: 'Modals',
  icon: 'some-files',
  disabled: true
}, {
  title: 'Wizards',
  icon: 'note-2',
  disabled: true
}, {
  title: 'Marketing',
  children: [{
    title: 'Mass Mailing',
    children: [{
      title: 'Email Templates',
      path: '/mass-mailing/template-design'
    }, {
      title: 'Subscriptions',
      path: '/mass-mailing/subscriptions'
    }, {
      title: 'Subscription Form',
      path: '/mass-mailing/subscription-form/create'
    }, {
      title: 'Groups',
      path: '/mass-mailing/groups',
    }, {
      title: 'Create Email Template',
      path: '/mass-mailing/template-design/create'
    }, {
      title: 'Mass Mailing Metrics',
      path: '/mass-mailing/metrics',
    }]
  },
  {
    title: 'Forms',
    children: [{
      title: 'Intake Forms',
      path: '/intake-forms',
    }, {
      title: 'Create Intake Form',
      path: '/intake-forms/create',

    }, {
      title: 'Preview Intake Form',
      path: '/intake-forms/preview',
    }]
  }
  ]
}, {
  title: 'Mass Mailing',
  icon: 'element-11',
  children: [{
    title: 'Email Templates',
    path: '/mass-mailing/template-design',
  }]
}, {
  title: 'Home',
  icon: 'element-11',
  children: [{
    title: 'Companies List',
    path: '/company/list',
  }]
}, {
  title: 'Home',
  icon: 'element-11',
  children: [{
    title: 'Discount Code Usage',
    path: '/discount-code-usage',
  }]
},{
  title: 'Home',
  icon: 'element-11',
  children: [{
    title: 'Discount Code List',
    path: '/discount-code',
  }]
},{
  title: 'Home',
  icon: 'element-11',
  children: [{
    title: 'Licenses List',
    path: '/licenses',
  }]
}];
export const MENU_MEGA = [{
  title: 'Home',
  path: '/'
},
{
  title: 'Contacts',
  path: '/contacts',
  permission: { action: 'access', subject: 'contact' },
},
// {
//   title: 'Contacts',
//   children: [{
//     title: 'Contacts',
//     path: '/contacts',
//     permission: { action: 'access', subject: 'contact' },
//   }, {
//     title: 'Create Contact',
//     path: '/contacts/create',
//     permission: { action: 'handle', subject: 'contact' },
//   }
//   ]
// }, 
{
  title: 'Matters',
  path: '/matters',
  permission: { action: 'access', subject: 'matter' },
},
// {
//   title: 'Matters',
//   children: [{
//     title: 'Matters',
//     path: '/matters',
//     permission: { action: 'access', subject: 'matter' },
//   }, {
//     title: 'Create Matter',
//     path: '/matters/create',
//     permission: { action: 'handle', subject: 'matter' },
//   },
//   ]
// },
{
  title: 'Tasks',
  path: '/reminders',
  permission: { action: 'access', subject: 'reminder' },
},
{
  title: 'Secure File Sharing',
  path: '/shared-storage',
  permission: { action: 'access', subject: 'shared-storage' },
},
{
  title: 'Billing',
  children: [{
    title: 'Items',
    path: '/billing/items',
    permission: { action: 'handle', subject: 'items' },
  }, {
    title: 'Expenses',
    path: '/billing/expense',
    permission: { action: 'handle', subject: 'expense' },
  }, {
    title: 'Flat Fees ',
    path: '/billing/flat-fees',
    permission: { action: 'handle', subject: 'flat-fees' },
  },
  {
    title: 'Invoices',
    path: '/billing/invoices/invoice',
    permission: { action: 'access', subject: 'invoice' },
  },
  ],
}, {
  title: 'Basic Setup ',
  children: [{
    title: 'Manage Users',
    icon: 'people',
    children: [{
      title: 'Users',
      icon: 'users',
      path: '/account/members/users',
      permission: { action: 'handle', subject: 'staff' },
    },
    {
      title: 'Roles & Permissions',
      icon: 'key',
      path: '/account/members/roles',
      permission: { action: 'handle', subject: 'role' },
    }]
  }, {
    title: 'Invoice Setup',
    icon: 'color-swatch',
    children: [{
      title: 'Expense Categories',
      path: '/billing/expense/category',
      icon: 'chart-pie-too',
      permission: { action: 'handle', subject: 'expense' },
    }, {
      title: 'Invoice Templates',
      path: '/billing/invoice/invoice-template',
      icon: 'cheque',
      permission: { action: 'access', subject: 'invoice' },
    }, {
      title: 'Taxes',
      path: '/billing/taxes',
      icon: 'bill',
      permission: { action: 'handle', subject: 'tax' },
    }]
  }, {
    title: 'Email Setup',
    icon: 'directbox-default',
    children: [{
      title: 'Email Signature',
      path: '/mass-mailing/signature',
      icon: 'message-edit',
      permission: { action: 'access', subject: 'mass-mailing' }
    },]
  }, {
    title: 'Data Import Details',
    // title: 'Data Import',
    path: '/data-import/details',
    permission: { action: 'access', subject: 'import' },
  }, {
    title: 'Contact Type',
    path: '/contacts/contact-type',
    permission: { action: 'access', subject: 'contact' },
  }, {
    title: 'Specialties',
    path: '/contacts/specialities',
    permission: { action: 'access', subject: 'contact' },
  }, {
    title: 'Custom Fields',
    path: '/account/home/custom-fields',
  }, {
    title: 'Record Types',
    path: '/account/home/record-types',
    permission: { action: 'access', subject: 'matter' },
  }, {
    title: 'Tags',
    path: '/account/home/tags',
  }, {
    title: 'Client Portal Guests',
    path: '/client-portal/guests',
    permission: { action: 'share', subject: 'matter-files' },
  },
    // {
    //   title: 'Recycle Bin',
    //   path: '/recycle-bin',
    // }, 
    // {
    //   title: 'Fields Mapping',
    //   path: '/account/home/map-fields',
    // }
  ],
}, {
  title: 'Referrals',
  children: [
    {
      title: 'Attorney Registration Requests',
      path: '/account/home/referral-request',
      permission: { action: 'handle', subject: 'referral-request' },
    },
    {
      title: 'Add Referred Contact',
      path: '/account/home/referral-attorney',
      permission: { action: 'handle', subject: 'attorney' },
    },
    {
      title: 'Referred Contact List',
      path: '/account/home/referred-contact-list',
      permission: { action: 'handle', subject: 'referral-contact' },
    }
  ]
}, {
  title: 'Marketing',
  children: [{
    title: 'Mass Mailings',
    // icon: 'sms',
    children: [{
      icon: 'graph-up',
      title: 'Email Metrics',
      path: '/mass-mailing/metrics',
      permission: { action: 'access', subject: 'mass-mailing' },
    }, {
      icon: 'directbox-default',
      title: 'Email Templates',
      path: '/mass-mailing/template-design',
      permission: { action: 'access', subject: 'mass-mailing' },
    }, {
      icon: 'people',
      title: 'Groups',
      path: '/mass-mailing/groups',
      permission: { action: 'access', subject: 'mass-mailing' },
    }, {
      icon: 'messages',
      title: 'Subscriptions',
      path: '/mass-mailing/subscriptions',
      permission: { action: 'access', subject: 'mass-mailing' },
    }
    ]
  }, {
    title: 'Forms',
    path: '/intake-forms',
    permission: { action: 'access', subject: 'intake-form' },
  },
    // {
    //   title: 'Fields Mapping',
    //   path: '/account/home/map-fields',
    // }
  ],
},
//  {
//   title: 'Mass Mailing',
//   children: [{
//     title: 'Email Metrics',
//     path: '/mass-mailing/metrics',
//     permission: { action: 'access', subject: 'mass-mailing' },
//   }, {
//     title: 'Email Templates',
//     path: '/mass-mailing/template-design',
//     permission: { action: 'access', subject: 'mass-mailing' },
//   }, {
//     title: 'Groups',
//     path: '/mass-mailing/groups',
//     permission: { action: 'access', subject: 'mass-mailing' },
//   }, {
//     title: 'Subscriptions',
//     path: '/mass-mailing/subscriptions',
//     permission: { action: 'access', subject: 'mass-mailing' },
//   }
//   ]
// }, 
{
  title: <FormattedMessage id="REFERRED.REFERRAL" />,
  children: [
    {
      title: <FormattedMessage id="REFERRED.ADD_REFERRED_CONTACT" />,
      path: '/account/home/referral-attorney',
      permission: { action: 'handle', subject: 'attorney' },
    },
    {
      title: <FormattedMessage id="REFERRED.REFERRED_CONTACT_LIST" />,
      path: '/account/home/attorney-referred-contact-list',
      permission: { action: 'handle', subject: 'attorney' },
    }
  ]
}, {
  title: 'Reports',
  children: [{
    title: 'Case Counts',
    path: '/reports/case-counts',
    permission: { action: 'access', subject: 'reports' },
  }, {
    title: 'AR Report – Due Invoices',
    path: '/reports/ar-report',
    permission: { action: 'access', subject: 'ar-reports' },
  }, {
    title: 'Raw Data Report',
    path: '/reports/raw-data-report',
    permission: { action: 'access', subject: 'raw-data-reports' },
  }, {
    title: 'ADHOC Report',
    path: '/reports/adhoc-report',
    permission: { action: 'access', subject: 'adhoc-reports' },
  }]
}, {
  title: 'Documents',
  children: [{
    title: 'E-Signature Documents',
    path: '/documents/e-signature-documents',
    permission: { action: 'access', subject: 'documents' },
  }, {
    title: 'Document Templates',
    path: '/documents/document-templates',
    permission: { action: 'access', subject: 'document-template' },
  }, {
    title: 'Letter Templates',
    path: '/documents/letter-templates',
    permission: { action: 'access', subject: 'letter-template' },
  }, {
    title: 'Demand Letters',
    path: '/documents/demand-letters',
    permission: { action: 'access', subject: 'demand-letter' },
  },]
},
  // {
  //   title: 'Intake Forms',
  //   path: '/intake-forms',
  //   permission: { action: 'access', subject: 'intake-form' },
  // }, 
  // {
  //   title: 'Data Import',
  //   children: [{
  //     title: 'Import your data',
  //     path: '/data-import/import',
  //     permission: { action: 'access', subject: 'ar-reports' },
  //   }, {
  //     title: 'Data Import Details',
  //     path: '/data-import/details',
  //     permission: { action: 'access', subject: 'raw-data-reports' },
  //   },]
  // },
  // {
  //   title: 'Data Import',
  //   path: '/data-import/details',
  //   permission: { action: 'access', subject: 'import' },
  // }
];
export const MENU_ROOT = [{
  title: 'Public Profile',
  icon: 'profile-circle',
  rootPath: '/public-profile/',
  path: 'public-profile/profiles/default',
  childrenIndex: 2
}, {
  title: 'Account',
  icon: 'setting-2',
  rootPath: '/account/',
  path: '/',
  childrenIndex: 3
}, {
  title: 'Network',
  icon: 'users',
  rootPath: '/network/',
  path: 'network/get-started',
  childrenIndex: 4
}, {
  title: 'Authentication',
  icon: 'security-user',
  rootPath: '/authentication/',
  path: 'authentication/get-started',
  childrenIndex: 5
}];